import { Grid, TypographyProps, useTheme, CircularProgress } from "@mui/material";
import MxIcons from "../MxIcons";
import {
  IconCircleCheck,
  IconExclamationCircle,
  IconInfoCircle,
  IconXboxX
} from "@tabler/icons-react";

export interface MxAlertIconProps {
  type?: "success" | "error" | "warning" | "info" | "default" | "loading";
  color?: TypographyProps["color"];
}
function MxAlertIcon(props: MxAlertIconProps) {
  const theme = useTheme();
  const { type = "default", color = "primary" } = props;

  return (
    <Grid
      item
      xs="auto"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: 100,
        height: "auto",
        // marginLeft: 1,
        position: "relative"
      }}
    >
      <Grid
        item
        sx={{
          borderRadius: "100%",
          width: 60,
          height: 60,
          backgroundColor: theme.palette.grey[200],
          position: "absolute",
          padding: 1.5,
          opacity: 0.1
        }}
      ></Grid>
      {type === "loading" ? (
        <CircularProgress size={40} sx={{ color: color }} />
      ) : (
        <MxIcons size={40} color={color}>
          {type === "success" && <IconCircleCheck stroke={1.8} />}
          {type === "warning" && <IconExclamationCircle stroke={1.8} />}
          {type === "error" && <IconXboxX stroke={1.8} />}
          {type === "info" && <IconInfoCircle stroke={1.8} />}
          {type === "default" && <IconCircleCheck stroke={1.8} />}
        </MxIcons>
      )}
    </Grid>
  );
}

export default MxAlertIcon;
